import { render, staticRenderFns } from "./LaudoRenovabio.vue?vue&type=template&id=f1ecb1fe&scoped=true&lang=pug"
import script from "./LaudoRenovabio.vue?vue&type=script&lang=js"
export * from "./LaudoRenovabio.vue?vue&type=script&lang=js"
import style0 from "./LaudoRenovabio.vue?vue&type=style&index=0&id=f1ecb1fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ecb1fe",
  null
  
)

export default component.exports